@import "../../../styles/mixins/svs-design-system";
@import "../../../styles/variables";

.widget-container {
  box-sizing: border-box;
  background-color: white;
  margin-bottom: 20px;
  cursor: pointer;
  overflow: hidden;
  text-decoration: none;
  padding: 16px 24px 24px 24px;

  p {
    font-size: 18px;
    margin: 0 0 16px 0;
  }

  &__sidepanel {
    padding: 0 16px;
  }
}

.category-list {
  display: flex;
  gap: 8px;
  margin-bottom: 40px;
  overflow-x: hidden;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  cursor: grab;

  &__sidepanel {
    display: flex;
    gap: 8px;
    padding-bottom: 16px;
    overflow-x: hidden;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    cursor: grab;
  }
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: white;
}

.category-list__sidepanel::-webkit-scrollbar {
  display: none;
}

.product-card {
  qds-standalone-link {
    --qds-control-standard-height: auto;
    overflow: hidden;
    background: white;
    height: 223px;
    margin: 0 8px 13px 8px;
    padding: 21px 12px 16px 12px;
    box-shadow: 0px 6.66px 17.12px -6.66px #3333332e;
    min-width: 145px;
    max-width: 211px;
    display: flex;
    flex-direction: column;

    img {
      height: 100px;
      margin-left: auto;
      margin-right: auto;
      display: block;
    }

    p {
      margin: 18px 0 8px 0;
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
      color: #626469;
    }

    span {
      font-size: 16px;
      font-weight: 400;
      line-height: 25px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.product-card-list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  &__sidepanel-mobile {
    display: flex;
    flex-direction: column;

    .product-card {
      qds-standalone-link {
        --qds-control-standard-height: auto;
        overflow: hidden;
        background: white;
        width: 95%;
        height: auto;
        min-width: none;
        max-width: none;
        margin: 0 16px 12px 0;
        padding: 16px 12px;
        box-shadow: 0px 6.66px 17.12px -6.66px #3333332e;
        display: -webkit-inline-box;

        span {
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            height: 51px;
          }

          span {
            display: flex;
            flex-direction: column;
            margin-left: 12px;
            align-items: flex-start;

            p {
              font-size: 14px;
              font-weight: 700;
              line-height: 14px;
              margin: 0 0 8px 0;
              text-decoration: none;
            }

            span {
              font-size: 16px;
              font-weight: 400;
              line-height: 25px;
              margin: 0;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}

se-carousel-item {
  max-width: 251px !important;
  min-width: 251px !important;
}
